import { Home, LogOut, Search, CreditCard, Users, Clock, Sparkles, FolderIcon } from "lucide-react"

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "./sidebar"

const org = process.env.REACT_APP_ORG

export function AppSidebar(props: {hasPro: boolean, hasFiles: boolean, logout: () => Promise<void>}) {
  // Handle navigation without page reload
  const handleNavigate = (e: React.MouseEvent<HTMLAnchorElement>, item: any) => {
    if (item.action) {
      item.action();
      return;
    }

    e.preventDefault();
    if ((item.url && !item.isPro && !item.isFiles) || (item.isPro && props.hasPro) || (item.isFiles && props.hasFiles)) {
      window.history.pushState({}, '', item.url);

      // Dispatch a navigation event that App.tsx can listen to
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    }
  };

  // Menu items.
  const items = [
    {
      title: "Home",
      url: "/",
      icon: Home,
    },
    {
      title: "Search",
      url: "/search",
      icon: Search
    },
    {
      title: "Recent Matters",
      url: "/matters/recent",
      icon: Clock,
      isPro: true,
    },
    {
      title: "Users",
      url: "/users",
      icon: Users,
    },
    {
      title: "Files",
      url: "/files",
      icon: FolderIcon,
      isFiles: true,
    },
    {
      title: "Account",
      url: "/account",
      icon: CreditCard,
    },
    {
      title: "Log Out",
      action: props.logout,
      icon: LogOut,
    },
  ]

  return (
    <Sidebar>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Menu</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => ( item.isFiles && !props.hasFiles ? null :
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <a
                      onClick={(e) => handleNavigate(e, item)}
                      href={(!item.url || (item.isPro && !props.hasPro) || (item.isFiles && !props.hasFiles)) ? "#" : item.url}
                      className={(item.isPro && !props.hasPro) || (item.isFiles && !props.hasFiles) ? "opacity-60" : ""}
                    >
                      <item.icon />
                      <span>{item.title}</span>
                      {item.isPro && !props.hasPro && (
                        <span className="ml-2 inline-flex items-center rounded-md bg-amber-50 px-2 py-1 text-xs font-medium text-amber-700 ring-1 ring-inset ring-amber-500">
                          <Sparkles className="mr-1 h-3 w-3" />
                          PRO
                        </span>
                      )}
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}
